import { render, staticRenderFns } from "./NewSalesSearch.vue?vue&type=template&id=3a836b3e&"
import script from "./NewSalesSearch.vue?vue&type=script&lang=js&"
export * from "./NewSalesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports